// appStorage — limit miejsca na materiały (A22) tam, gdzie użytkownik go DOTYKA:
// miernik nad wgrywaniem i blokada, gdy pack się nie zmieści.
// Zamówienie P04 (INFO-P04-008). Klucze lustrzane z ../en/appStorage.ts.
//
// Karta „Miejsce na materiały” w Rozliczeniach ma własne klucze (`appBilling.storage.*`,
// zamówienie P01) — to inny ekran i inna rozmowa. Zdanie o 90 dniach retencji żyje
// TYLKO tam, żeby nie rozjechały się dwie wersje tej samej obietnicy.
export const appStorage = {
  meter: {
    label: 'Miejsce na materiały',
    used: '{used} z {quota}',
    full: 'Limit wyczerpany',
    // Ostrzegamy ZANIM user wgra 4 GB i zobaczy błąd na końcu paska postępu.
    almostFull: 'Zostało {free} - duży plik może się nie zmieścić.',
  },
  upload: {
    blocked: 'Nie zmieści się w Twoim limicie',
    blockedBody: 'Zostało {free}. Usuń materiał, którego już nie używasz, albo przejdź na wyższy plan.',
    manage: 'Zarządzaj materiałami',
    seePlans: 'Zobacz plany',
  },
  plan: {
    none: 'Bez planu masz tylko miejsce na materiały z pakietu startowego.',
  },
}
